import React from "react";
import SagaScreen from "kit/SageScreen";

const Onboarding: React.FC = () => {
    return (
        <SagaScreen>
            <h2>Onboarding</h2>
            <p>
                Thank you for creating an account with Rend A Hand! There are a
                few more things that you need to do to.
            </p>
        </SagaScreen>
    );
};

export default Onboarding;
